import { render } from "./UnsuccessfulImportExcel.vue?vue&type=template&id=21da3f00"
import script from "./UnsuccessfulImportExcel.vue?vue&type=script&lang=js"
export * from "./UnsuccessfulImportExcel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\82\\s\\SimpleSums\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__